export const POST_USER = "POST_USER";
export const GET_USERS = "GET_USERS";
export const DELETE_USER = "DELETE_USER";
export const PUT_USER = "PUT_USER";
export const INICIARS = "INICIAR_SESION";
export const CERRARSESION = "CERRADO_DE_SESION";
export const INICIOFACEBOOK = "INICIOSESIONCONFACEBOOK ";
export const RESETPASSWORD = "RESETPASSWORD";
export const NUEVA_CONTRASENIA = "NUEVA_CONTRASENIA";
export const GET_USUARIO_POR_TOKEN = "GET_USUARIO_POR_TOKEN";